import React from 'react'

import * as h2Api from '../h2Api'
import * as contentSnippetWizardActions from '../actions/contentSnippetWizard'
//import {graduationYearSelection, isValidEmail} from './index'

const initialState = {
  isPopupOpened: false,
  submitInProgress: false,
  profileId: null,
  profileType: null,
  currentStepIndex: 0,
  isLoading: false,
  submitError: null,
  selectedContentTypeIndex: null,
  uploadProgress: {
    active: false,
    pctComplete: 5,
    selected: ''
  },
  //selectedContentTypeIndex: contentSnippetWizardActions.CONTENT_LISTING.idx,
  title: '',
  body: '',
  idForEdit: null,
  [contentSnippetWizardActions.CONTENT_YOUTUBE.idx]: {
    videoId: null
  },
  [contentSnippetWizardActions.CONTENT_ADDRESS.idx]: {
    laddress: null,
    lcity: null,
    lstate: null,
    lzip: null
  },
  [contentSnippetWizardActions.CONTENT_TWITTER.idx]: {
    twitterName: null
  },
  [contentSnippetWizardActions.CONTENT_LISTING_FILES.idx]: {
    files: []
  },
  [contentSnippetWizardActions.CONTENT_PHOTO.idx]: {
    files: []
  },
  [contentSnippetWizardActions.CONTENT_LISTING.idx]: {
    listingtype: null,
    //listingtype: 3,
    values: []
  },
  [contentSnippetWizardActions.CONTENT_LISTING_COLLEGE.idx]: {
    listingtype: null,
    //listingtype: 3,
    values: []
  },
  [contentSnippetWizardActions.CONTENT_LISTING_JOB_OPENING.idx]: {
    listingtype: null,
    //listingtype: 3,
    values: []
  },
  [contentSnippetWizardActions.CONTENT_LISTING_DIRECT_EMPLOYER_JOB_OPENING.idx]: {
    listingtype: null,
    //listingtype: 3,
    searchTerm: '',
    companyName: '',
    ein: '',
    defaultZip: '',
    defaultZipRadius: '',
    defaultState: '',
    autoExpandSearch: false,
    values: []
  },
  [contentSnippetWizardActions.CONTENT_CAREER_CLUSTER.idx]: {
    listingtype: null,
    //listingtype: 3,
    values: []
  },
  [contentSnippetWizardActions.CONTENT_LISTING_ADDITIONAL_RESOURCES.idx]: {
    listingtype: null,
    //listingtype: 3,
    values: []
  },
  [contentSnippetWizardActions.CONTENT_LISTING_INDUSTRIES.idx]: {
    listingtype: null,
    //listingtype: 3,
    values: []
  },
  [contentSnippetWizardActions.CONTENT_LISTING_OTHER_PROFILES.idx]: {
    listingtype: null,
    //listingtype: 3,
    values: []
  },
  [contentSnippetWizardActions.CONTENT_LISTING_OCCUPATIONS.idx]: {
    listingtype: null,
    //listingtype: 3,
    values: []
  },
  [contentSnippetWizardActions.CONTENT_PROMOTE_FILES.idx]: {
    fileId: {},
    buttonText: null,
    showButton: true,
    showThumbnail: true
  },
  [contentSnippetWizardActions.CONTENT_SUMMARY_QUALIFICATIONS.idx]: {
    selectedResume: { id: null, title: null },
    workExperience: { id: null, title: null },
    education: { id: null, title: null }
  },
  [contentSnippetWizardActions.CONTENT_EMPLOY_GOALS.idx]: {
    selections: []
  },
  [contentSnippetWizardActions.CONTENT_SURVEY.idx]: {
    buttonText: '',
    fragmentId: '',
    surveyId: null
  },
  [contentSnippetWizardActions.CONTENT_EMPLOY_CRITERIA.idx]: {
    selections: []
  },
  [contentSnippetWizardActions.CONTENT_CONTACT_INFO.idx]: {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    position: '',
    address: '',
    city: '',
    state: '',
    zip: '',
    notes: ''
  },
  // suggestion lists for various chip multi select
  suggestions: {
    occupations: [],
    industries: []
  },
  listOfFiles: {
    files: []
  },
  listOfSurveys: [],
  allowedTypes: contentSnippetWizardActions.ALL_CONTENT_TYPES
  //,graduationYearSuggestions: graduationYearSelection(true)
}

export default (state = initialState, action) => {
  switch (action.type) {
    case contentSnippetWizardActions.CONTENT_WIZARD_OPEN_CLOSE:
      const cleanState = {
        ...initialState,
        allowedTypes: state.allowedTypes
      }

      if (action.isOpened) {
        return {
          ...cleanState,
          isPopupOpened: true,
          profileId: action.profileId,
          profileType: action.profileType
        }
      }

      return { ...cleanState, isPopupOpened: false }

    case contentSnippetWizardActions.CONTENT_WIZARD_SELECT_CONTENT_TYPE:
      return {
        ...state,
        selectedContentTypeIndex: action.idx

        /*
         * we keep the state of content types when the type changes, if the user re choses
         * the type later, it's still there, but we could reset it with :
         */

        // [action.idx]: initialState[action.idx]
      }

    case contentSnippetWizardActions.CONTENT_WIZARD_NEXT:
      const isSQ =
        state.selectedContentTypeIndex ===
        contentSnippetWizardActions.CONTENT_SUMMARY_QUALIFICATIONS.idx
      const rState =
        state[[contentSnippetWizardActions.CONTENT_SUMMARY_QUALIFICATIONS.idx]]
      const stepSize =
        isSQ && rState.selectedResume.isDocument && state.currentStepIndex == 2 ? 3 : 1

      return { ...state, currentStepIndex: state.currentStepIndex + stepSize }

    case contentSnippetWizardActions.CONTENT_WIZARD_PREVIOUS:
      if (state.currentStepIndex == 0) {
        return state
      }

      const isSQ2 =
        state.selectedContentTypeIndex ===
        contentSnippetWizardActions.CONTENT_SUMMARY_QUALIFICATIONS.idx
      const rState2 =
        state[[contentSnippetWizardActions.CONTENT_SUMMARY_QUALIFICATIONS.idx]]
      const stepSize2 =
        isSQ2 && rState2.selectedResume.isDocument && state.currentStepIndex == 5 ? 3 : 1

      return { ...state, currentStepIndex: state.currentStepIndex - stepSize2 }

    case contentSnippetWizardActions.CONTENT_WIZARD_FIELD_CHANGE:
      if (action.isRoot) {
        return {
          ...state,
          [action.storeKeyId]: action.value
        }
      }

      const itm = {
        ...state,
        [state.selectedContentTypeIndex]: {
          ...state[state.selectedContentTypeIndex],
          [action.storeKeyId]: action.value
        }
      }

      //console.log(itm)
      return itm

    case contentSnippetWizardActions.CONTENT_WIZARD_SUBMIT:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        // this will close and reset the dialog
        return initialState
      }

      if (action.restCall.status === h2Api.REST_CALL_STATUS.ERROR) {
        return {
          ...state,
          submitError: action.restCall.response,
          submitInProgress: false
        }
      }

      return {
        ...state,
        submitError: null,
        submitInProgress: true
      }

    case contentSnippetWizardActions.CONTENT_WIZARD_SUGGEST:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        return {
          ...state,
          suggestions: {
            ...state.suggestions,
            [action.suggestionType]: action.restCall.result
          }
        }
      }

      return state

    case contentSnippetWizardActions.CONTENT_WIZARD_ADD_OR_REMOVE_CONTENT_LISTING_OBJECT: {
      const listingState = state[state.selectedContentTypeIndex]
      //console.log("Making a list, checking it twice");
      const newList = action.isAdd
        ? [...listingState.values, action.choiceObject]
        : listingState.values.filter(element => element !== action.choiceObject)

      //console.log("ELE", contentSnippetWizardActions.CONTENT_LISTING.idx, listingState, newList, action, state.selectedContentTypeIndex)
      return {
        ...state,
        [state.selectedContentTypeIndex]: {
          ...listingState,
          values: newList
        }
      }
    }

    case contentSnippetWizardActions.CONTENT_WIZARD_LIST_FILES:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        return {
          ...state,
          listOfFiles: action.restCall.result
        }
      }

      return state

    case contentSnippetWizardActions.CONTENT_WIZARD_LOAD_SURVEYS:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        return {
          ...state,
          listOfSurveys: action.restCall.result
        }
      }

      return state

    case contentSnippetWizardActions.CONTENT_WIZARD_FILE_UPLOAD:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        return {
          ...state,
          listOfSurveys: action.restCall.result
        }
      }

      return state

    case contentSnippetWizardActions.CONTENT_WIZARD_FILE_UPLOAD: {
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        console.log('CALL', action.restCall, state.listOfFiles, state)
        const listingState =
          state[[contentSnippetWizardActions.CONTENT_LISTING_FILES.idx]]
        const fileId = []

        if (action.restCall.result.files.length > 0) {
          fileId.push(action.restCall.result.files[0])
        }

        return {
          ...state,
          listOfFiles: {
            ...state.listOfFiles,
            files: state.listOfFiles.files.concat(action.restCall.result.files)
          },
          uploadProgress: {
            ...state.uploadProgress,
            active: false
          },
          [contentSnippetWizardActions.CONTENT_LISTING_FILES.idx]: {
            ...listingState,
            files: listingState.files.concat(fileId)
          }
        }
      }

      if (action.restCall.status === h2Api.REST_CALL_STATUS.ERROR) {
        return {
          ...state,
          uploadProgress: {
            ...state.uploadProgress,
            active: false
          }
        }
      }

      if (action.restCall.status === h2Api.REST_CALL_STATUS.UPLOADING) {
        return {
          ...state,
          uploadProgress: {
            ...state.uploadProgress,
            active: true,
            pctComplete: action.restCall.complete
          }
        }
      }

      return state
    }

    case contentSnippetWizardActions.CONTENT_WIZARD_LIST_RESUMES:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        return {
          ...state,
          listOfResumes: action.restCall.result
        }
      }

      return state

    case contentSnippetWizardActions.CONTENT_WIZARD_LIST_RESUME_CONTENT:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        return {
          ...state,
          resumeContent: action.restCall.result
        }
      }

      return state

    case contentSnippetWizardActions.CONTENT_WIZARD_ADD_FILE: {
      const listingState = state[[contentSnippetWizardActions.CONTENT_LISTING_FILES.idx]]

      return {
        ...state,
        [contentSnippetWizardActions.CONTENT_LISTING_FILES.idx]: {
          ...listingState,
          files: [...listingState.files, action.file]
        }
      }
    }

    case contentSnippetWizardActions.CONTENT_WIZARD_ADD_FILE_TO_SLIDESHOW: {
      const listingState = state[[contentSnippetWizardActions.CONTENT_PHOTO.idx]]

      return {
        ...state,
        [contentSnippetWizardActions.CONTENT_PHOTO.idx]: {
          ...listingState,
          files: [...listingState.files, action.file]
        }
      }
    }

    case contentSnippetWizardActions.CONTENT_WIZARD_REMOVE_FILE_FROM_SLIDESHOW:
      const listingState2 = state[[contentSnippetWizardActions.CONTENT_PHOTO.idx]]

      return {
        ...state,
        [contentSnippetWizardActions.CONTENT_PHOTO.idx]: {
          ...listingState2,
          files: listingState2.files.filter(f => f.id !== action.file.id)
        }
      }

    case contentSnippetWizardActions.CONTENT_WIZARD_SELECT_FILE: {
      const listingState = state[[contentSnippetWizardActions.CONTENT_PROMOTE_FILES.idx]]
      const rV = {
        ...state,
        [contentSnippetWizardActions.CONTENT_PROMOTE_FILES.idx]: {
          ...listingState,
          fileId: action.file
        }
      }

      console.log(rV)

      return rV
    }

    case contentSnippetWizardActions.CONTENT_WIZARD_SELECT_SURVEY:
      const listingState = state[[contentSnippetWizardActions.CONTENT_SURVEY.idx]]

      console.log(`Adding to${contentSnippetWizardActions.CONTENT_SURVEY.idx}`)

      return {
        ...state,
        [contentSnippetWizardActions.CONTENT_SURVEY.idx]: {
          ...listingState,
          surveyId: action.survey
        }
      }

    case contentSnippetWizardActions.CONTENT_WIZARD_GET_TYPES:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        const result = action.restCall.result
        const sectionIds = result.sections.map(s => s.id)
        const sectionTypes = contentSnippetWizardActions.ALL_CONTENT_TYPES.filter(t =>
          sectionIds.includes(t.idx)
        )

        console.log(result, sectionIds, sectionTypes)

        return {
          ...state,
          allowedTypes: sectionTypes
        }
      }

      return state

    case contentSnippetWizardActions.FORM_SUBMIT_START:
      return {
        ...state,
        isLoading: true
      }

    default:
      return state
  }
}
